import { Box, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { useRootTranslation } from 'utils/hooks';

const rootT = 'drawers.tracksImportResolver';

export type AliasFeedbackKind = 'added' | 'removed' | 'conflict';

type AliasFeedbackProps = {
  feedback: AliasFeedbackKind;
  conflictTrackTitle?: string;
};

const AliasFeedback = ({ feedback, conflictTrackTitle }: AliasFeedbackProps) => {
  const t = useRootTranslation(rootT);

  if (feedback === 'conflict') {
    return (
      <Box sx={{ display: 'flex', gap: 0.5, color: 'error.main' }}>
        <CancelOutlinedIcon sx={{ fontSize: 16, flexShrink: 0 }} />
        <Typography variant="caption">{t('aliasFeedback.conflict', { trackTitle: conflictTrackTitle })}</Typography>
      </Box>
    );
  }

  const added = feedback === 'added';
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: added ? 'success.main' : 'error.main' }}>
      {added ? (
        <CheckCircleOutlineIcon sx={{ fontSize: 16, flexShrink: 0 }} />
      ) : (
        <CancelOutlinedIcon sx={{ fontSize: 16, flexShrink: 0 }} />
      )}
      <Typography variant="caption" sx={{ whiteSpace: 'nowrap' }}>
        {added ? t('aliasFeedback.added') : t('aliasFeedback.removed')}
      </Typography>
    </Box>
  );
};

export default AliasFeedback;
